import { AddressBookFolderEnum } from '../../../generated';

const isFolderSelected = (
  selectedFolders: AddressBookFolderEnum[],
  folder: AddressBookFolderEnum,
) => selectedFolders.find((selectedFolder) => selectedFolder === folder);

export { isFolderSelected };
